import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";
import WorkSection from "./Sections/WorkSection.jsx";



class PortPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          brand="MGEC" 
          rightLinks={<HeaderLinks />}
          fixed
          color="white"
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/port.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
              <br/>
              <br/>
                <h2 className={classes.title}>
                Port Operation
                </h2>
                <br />
                 <h4 className={classes.tit}>
              We, MGEC, focus to expedite Myanmar’s international trade by providing world‑class port operation for manufacturing sector growth and related engineering services. 
                 </h4>
                    
                 <br />
                <br />
                <br />
               
                
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>


        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
      <WorkSection/>

      
          </div>
        </div>
       <Footer/>
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(PortPage);



// WEBPACK FOOTER //
// ./src/views/PortPage/PortPage.jsx